import React from 'react';
import CONFIG from '../../../config';

import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';


function CodePromo({ id, configuration, setConfiguration, code, value, commercial }) {
  const handleClickDelete = React.useCallback((e) => {
    axios.delete(CONFIG.API_URL + '/api/delete_codepromo/' + id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setConfiguration(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);

  return (
    <>
      <div className="col-span-12 h-min grid grid-cols-10 pl-2 mb-2 mr-2 items-center bg-gray-100 rounded-md shadow-md shadow-gray-100 justify-center border border-gray-200">
        <div className="col-span-3 whitespace-nowrap pr-2 text-ellipsis overflow-hidden">
          {code}
        </div>
        <div className="col-span-3 whitespace-nowrap pr-2 text-ellipsis overflow-hidden">
          {value}
        </div>
        <div className="col-span-3 whitespace-nowrap pr-2 text-ellipsis overflow-hidden">
          ({commercial ? "Pour commercial" : "Pour client"})
        </div>
        <div className="flex">
          <IconButton onClick={handleClickDelete}><CloseIcon fontSize="small"></CloseIcon></IconButton>
        </div>
      </div>
    </>
  );
}

export default CodePromo;